import { render, staticRenderFns } from "./b-input.vue?vue&type=template&id=6e9f7b5e&scoped=true"
import script from "./b-input.vue?vue&type=script&lang=js"
export * from "./b-input.vue?vue&type=script&lang=js"
import style0 from "./b-input.vue?vue&type=style&index=0&id=6e9f7b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f7b5e",
  null
  
)

export default component.exports